import React from 'react';

export const OverlayContext = React.createContext({ onClose: () => {} });
